module.exports = __webpack_public_path__ + "media/images/emoticons/sleepy-f15fbc438eb669ab3cbe139862ad0777.gif";